import moment from 'moment'

export const ncrUser = {
    id: '',
    ncrId: '',
    ncrNo: '',
    conformanceTypeId: '',
    conformanceTypeName: '',
    ncrDate: moment().format('YYYY-MM-DD'),
    memberId: '',
    memberName: '',
    description: '',
    happenedBefore: 0,
    createdBy: '',
    updatedBy: '',
    createdAt: moment().format('YYYY-MM-DD'),
    updatedAt: moment().format('YYYY-MM-DD'),
}
